var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import _ from 'lodash';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import GLOBAL_VUE from '../../globalVue';
import PurchaseOrderForUpperSupService from '../../api/PurchaseOrderForUpperSupService';
import { summaries } from "../../helper/util";
import RegexStr from "../../common/RegexStr";
import AddDialog from "./components/GoodAdd.vue";
import Header from "./components/AddHeader.vue";
import TableHeaderToolTip from './components/TableHeaderToolTip.vue';
import RequiredMixin from "../../components/renderHeader/RequiredMixin";
var phoneRegex = new RegExp(RegexStr.phone);
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 320;
        _this.data = [];
        _this.formData = {
            supplier_upper_id: '',
            purchase_time: new Date().format('yyyy-MM-dd'),
            order_arriveddate: new Date().format('yyyy-MM-dd'),
            organ_id: '',
            depot_id: '',
            purchaser_name: '',
            purchaser_phone: '',
            agent_order_code: '',
            purchaser_id: '',
            order_icomment: '',
            is_modify_oamount: 1,
            is_modify_uprice: 1,
            is_show_uprice: 1,
            concat_address: ''
        };
        _this.handleStatus = EHandleStatus.Add;
        _this.orderid = '';
        _this.canSave = true;
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.created = function () {
        this.PurchaseOrderForUpperSupService = PurchaseOrderForUpperSupService.getInstance();
        if (this.orderid) {
            this.handleStatus = EHandleStatus.Edit;
            this.getDetail();
        }
    };
    default_1.prototype.mounted = function () {
        this.tableHeight = document.documentElement.clientHeight - 360 - (this.handleStatus === EHandleStatus.Add ? 0 : 45);
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid
        };
        this.PurchaseOrderForUpperSupService.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            if (data.purchaser_id === 0) {
                data.purchaser_id = '';
            }
            (data.detail || []).forEach(function (item) {
                _this.calcGoodRow(item);
            });
            _this.data = data.detail;
            _this.formData = Object.assign({}, _this.formData, data);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.save = function () {
        var _this = this;
        var formData = this.formData;
        if (!this.checkSave()) {
            return;
        }
        if (!this.data || !this.data.length) {
            this.$message.warning("请添加货品");
            return;
        }
        this.canSave = false;
        if (this.handleStatus === EHanldeStatus.Add) {
            var data = this.data;
            var params = __assign({}, formData, { data: JSON.stringify(data) });
            this.PurchaseOrderForUpperSupService.addOrder(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success("保存成功");
                    window._czc.push(["_trackEvent", '采购订货添加', '采购订货添加保存']);
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            }).catch(function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            });
        }
        else {
            var data = this.data;
            var params = __assign({}, formData, { order_id: this.orderid, data: JSON.stringify(data) });
            delete params.detail;
            this.PurchaseOrderForUpperSupService.addOrder(params).then(function (res) {
                if (res.data.success) {
                    _this.$message.success("保存成功");
                    window._czc.push(["_trackEvent", '采购订货编辑', '采购订货编辑保存']);
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 500);
                }
            }, function (err) {
                _this.canSave = true;
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.message);
                _this.canSave = true;
            });
        }
    };
    default_1.prototype.checkSave = function () {
        if (!this.canHandleGoods()) {
            return false;
        }
        if (!this.formData.purchase_time) {
            this.$message.warning("请选择订货日期");
            return false;
        }
        if (!this.formData.order_arriveddate) {
            this.$message.warning("请选择预计到货日期");
            return false;
        }
        if (this.formData.purchaser_phone && !phoneRegex.test(this.formData.purchaser_phone)) {
            this.$message.warning("收货人手机号格式不正确");
            return false;
        }
        var flag = true, msg = [];
        this.data.map(function (row) {
            if ((!row.order_detail_tax_rate && row.order_detail_tax_rate !== 0) || row.order_detail_tax_rate < 0) {
                flag = false;
                msg.push('税率必填，税率大于等于0');
            }
            if ((!row.order_detail_amount && row.order_detail_amount !== 0) || row.order_detail_amount <= 0) {
                flag = false;
                msg.push('采购量必填，采购量大于0');
            }
            if ((!row.order_detail_uprice && row.order_detail_uprice !== 0) || row.order_detail_uprice < 0) {
                flag = false;
                msg.push('单价必填，单价大于等于0');
            }
        });
        if (!flag) {
            this.$message.warning('货品信息不可为空，税率大于等于0，采购量大于0，单价大于等于0。');
            return false;
        }
        return true;
    };
    default_1.prototype.canHandleGoods = function () {
        if (!this.formData.supplier_upper_id) {
            this.$message.warning("请选择供应商");
            return;
        }
        if (!this.formData.organ_id) {
            this.$message.warning("请选择采购机构");
            return;
        }
        if (!this.formData.depot_id) {
            this.$message.warning("请选择采购仓库");
            return;
        }
        return true;
    };
    default_1.prototype.toAdd = function () {
        var _this = this;
        if (!this.canHandleGoods()) {
            return false;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                supplier_upper_id: this.formData.supplier_upper_id,
                organ_id: this.formData.organ_id,
                depot_id: this.formData.depot_id,
            }
        }, {
            title: "添加货品",
            width: 900,
            height: 550
        });
        dialog.instance.$on("submit", function (res) {
            _this.data = res;
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Add) {
                window._czc.push(["_trackEvent", '采购订货添加', '添加货品']);
            }
            else {
                window._czc.push(["_trackEvent", '采购订货编辑', '添加货品']);
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择货品");
            return;
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
            if (_this.handleStatus === EHanldeStatus.Add) {
                window._czc.push(["_trackEvent", '采购订货添加', '删除货品']);
            }
            else {
                window._czc.push(["_trackEvent", '采购订货编辑', '删除货品']);
            }
        }, function (err) { });
    };
    default_1.prototype.emptyGood = function () {
        this.data = [];
    };
    default_1.prototype.changeGoodRow = function (row, type) {
        if (row[type])
            row[type] = String(row[type]).replace(/^(.*\..{4}).*$/, "$1");
        if (type == 'order_detail_tax_rate' || type == 'order_detail_amount' || type == 'order_detail_uprice') {
            if (row.order_detail_amount && row.order_detail_uprice) {
                row.order_detail_money = new Number(_.multiply(row.order_detail_amount * row.order_detail_uprice)).toFixedNoZero(2);
            }
            else {
                row.order_detail_money = row.order_detail_money ? row.order_detail_money : '';
            }
            if (row.order_detail_money && row.order_detail_tax_rate) {
                var taxMoney = 0;
                taxMoney = row.order_detail_money / (1 + row.order_detail_tax_rate / 100) * (row.order_detail_tax_rate / 100);
                taxMoney = new Number(taxMoney).toFixedNoZero(4);
                row.order_detail_tax_money = taxMoney;
            }
            else {
                row.order_detail_tax_money = 0;
            }
            if (row.order_detail_money) {
                var noTaxMoney = 0;
                noTaxMoney = row.order_detail_money - row.order_detail_tax_money;
                noTaxMoney = new Number(noTaxMoney).toFixedNoZero(4);
                row.order_detail_no_tax_money = noTaxMoney;
            }
            else {
                row.order_detail_no_tax_money = 0;
            }
        }
    };
    default_1.prototype.calcGoodRow = function (row) {
        if (row.order_detail_money && row.order_detail_tax_rate) {
            var taxMoney = 0;
            taxMoney = row.order_detail_money / (1 + row.order_detail_tax_rate / 100) * (row.order_detail_tax_rate / 100);
            taxMoney = new Number(taxMoney).toFixedNoZero(4);
            row.order_detail_tax_money = taxMoney;
        }
        else {
            row.order_detail_tax_money = 0;
        }
        if (row.order_detail_money) {
            var noTaxMoney = 0;
            noTaxMoney = row.order_detail_money - row.order_detail_tax_money;
            noTaxMoney = new Number(noTaxMoney).toFixedNoZero(4);
            row.order_detail_no_tax_money = noTaxMoney;
        }
        else {
            row.order_detail_no_tax_money = 0;
        }
    };
    default_1.prototype.getSummaries = function (param) {
        var sums = [];
        var showSum = ["order_detail_tax_rate", "order_detail_amount", "order_detail_uprice", "order_detail_money"];
        sums = summaries(param, showSum);
        sums[0] = '合计';
        sums[6] = '';
        sums[7] = '';
        sums[8] = '';
        return sums;
    };
    default_1 = __decorate([
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header,
                TableHeaderToolTip: TableHeaderToolTip
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            methods: {
                renderHeader: function (h, _a) {
                    var column = _a.column, $index = _a.$index;
                    return this.$createElement('TableHeaderToolTip', {
                        props: {
                            content: "税额=含税金额/(1+税率)*税率",
                            placement: "bottom"
                        }
                    }, '税额');
                }
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
